// src/components/CompetitionCard.tsx
import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  Box,
  //  Grid, // REMOVIDO: Eliminando o componente Grid
  Chip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
// CORREÇÃO: Importar o Modal e a Interface atualizados
import CompetitionDetailsModal, {
  Competition,
} from "../CompetitionDetailsModal";

export type { Competition };

interface CompetitionCardProps {
  token: string;
  competition: Competition;
  formatCurrency: (price: string) => string;
  // NOVO: Callback para atualizar o objeto Competition na lista principal (componente AVÔ)
  onCompetitionDataUpdated: (updatedCompetition: Competition) => void;
  onCompetitionDeleted: (deletedCompetitionId: string) => void;
}

const CompetitionCard: React.FC<CompetitionCardProps> = ({
  token,
  competition,
  onCompetitionDeleted,
  formatCurrency,
  onCompetitionDataUpdated, // Recebendo o callback do Avô
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getStatusProps = (status: string) => {
    switch (status) {
      case "ACTIVE":
        return { label: "ATIVA", color: "success" as const };
      case "DRAFT":
        return { label: "RASCUNHO", color: "warning" as const };
      case "CLOSED":
        return { label: "ENCERRADO", color: "default" as const };
      case "PRIZES_DISTRIBUTED":
        return { label: "PRÊMIOS DISTRIBUIDOS", color: "error" as const };
      default:
        return { label: status, color: "default" as const };
    }
  };

  const statusProps = getStatusProps(competition.status);

  // Função para repassar a atualização do Modal para o componente Avô (inalterada)
  const handleCompetitionUpdate = (updatedCompetition: Competition) => {
    onCompetitionDataUpdated(updatedCompetition);
  };

  const handleCompetitionDeleteSuccess = (deletedId: string) => {
    setIsModalOpen(false); // Fecha o modal após a exclusão
    onCompetitionDeleted(deletedId); // Chama o Avô para remover o Card
  };

  return (
    // SUBSTITUINDO GRID ITEM por Box com largura responsiva e padding
    <Box
      sx={{
        // Larguras para simular xs={12}, sm={6}, md={4}, lg={3}
        width: {
          xs: "100%",
          sm: "50%",
          md: "33.333%",
          lg: "25%",
        },
        padding: 1.5, // Simula spacing=3 (24px de espaçamento, requer 12px de padding por item)
        // Nota: O espaçamento do grid externo (container) deve ser replicado pelo padding
        // Aqui estamos assumindo que o container pai terá margin negativo para compensar
      }}
    >
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          boxShadow: 6,
          transition: "0.3s",
          "&:hover": { boxShadow: 10 },
        }}
      >
        <CardContent sx={{ flexGrow: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={1.5}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: "bold", pr: 1 }}
              title={competition.title}
            >
              {competition.title.length > 30
                ? competition.title.substring(0, 27) + "..."
                : competition.title}
            </Typography>
            <Chip
              label={statusProps.label}
              color={statusProps.color}
              size="small"
            />
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Tipo: {competition.scaleType}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Preço: {formatCurrency(competition.participationPrice)}
          </Typography>

          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Encerramento:{" "}
            {new Date(competition.closeDate).toLocaleDateString("pt-BR")}
          </Typography>
        </CardContent>

        <CardActions sx={{ justifyContent: "flex-end", p: 2, pt: 0 }}>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setIsModalOpen(true)}
            startIcon={<VisibilityIcon />}
            sx={{
              color: "#008870",
              borderColor: "#008870",
              "&:hover": {
                color: "#005848ff",
                borderColor: "#005848ff",
              },
            }}
          >
            Ver Mais
          </Button>
        </CardActions>
      </Card>

      {/* Modal de Detalhes */}
      {isModalOpen && (
        <CompetitionDetailsModal
          token={token}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          initialCompetition={competition}
          formatCurrency={formatCurrency}
          onCompetitionUpdated={handleCompetitionUpdate}
          onCompetitionDeleted={handleCompetitionDeleteSuccess}
        />
      )}
    </Box>
  );
};

export default CompetitionCard;
